import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const OpportunityConsideration = ({
    equityDetails,
}: Partial<{
    equityDetails: string;
}>) => (
    <>
        <Row>
            <ValueCell label="Details" value={equityDetails} />
        </Row>
    </>
);

export default OpportunityConsideration;
